import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { prependScheme } from '~/constants/routes'

interface Props {
  children: ReactNode
  route: string
  schemeId?: string | null
  withLink?: boolean
}

const MaybeLink = ({ children, route, schemeId, withLink = false }: Props) => {
  if (schemeId) {
    route = prependScheme(route, schemeId)
  }
  return withLink ? <Link to={route}>{children}</Link> : <>{children}</>
}

export default MaybeLink
